import { render, staticRenderFns } from "./TransporterButton.vue?vue&type=template&id=b1a90ada"
import script from "./TransporterButton.vue?vue&type=script&lang=js"
export * from "./TransporterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports